import React, { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import { toast } from "react-toastify";
import {
  pesticideGenerateReportBackend,
  buildBackendReportPayload,
  getMissingBackendReportFields,
} from "../../../../../actions/chemistry";
import { checkReadyReports, runQCApiPost } from "../../../../../actions/sendReports";
import "./ChemPesticidePreview.css";

function ChemPesticidePreview({
  sampleDetail,
  pdfModalData,
  handleClosePreview,
}) {
  const [modalData, setPdfModalData] = useState(pdfModalData);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPdfModalData(pdfModalData);
  }, [pdfModalData]);

  const handleSubmitReport = async () => {
    if (loading) {
      return;
    }

    const payload = buildBackendReportPayload(sampleDetail);
    const missingFields = getMissingBackendReportFields(payload);

    if (missingFields.length > 0) {
      toast.error(`Unable to generate the MRL report. Missing: ${missingFields.join(", ")}`);
      return;
    }

    try {
      setLoading(true);

      const result = await pesticideGenerateReportBackend(payload);

      if (!result?.success || result?.message !== "Success") {
        throw new Error(result?.message || "Unable to generate the MRL report.");
      }

      if (result?.sql_server_api_error) {
        toast.warning(
          `The report was generated, but SQL Server synchronization failed. ${result.sql_server_api_error}`,
        );
      } else {
        toast.success("MRL report generated successfully.");
      }

      await runQCApiPost({
        rerun: false,
        workorder_id_list: [{ wo_id: sampleDetail.workorder_id }],
      });
      await checkReadyReports();
      handleClosePreview(true);
    } catch (error) {
      toast.error(
        error?.response?.data?.message
        || error?.response?.data?.error
        || error?.response?.data?.detail
        || error?.message
        || "MRL report generation failed.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title=""
      open={modalData.open}
      maskClosable={false}
      closable={false}
      footer={false}
      destroyOnClose
      centered
      className="ChemPesticidePreview"
    >
      {modalData.pdfUrl && <object className="ChemPesticidePreviewObject" data={`${modalData.pdfUrl}#toolbar=0`} aria-label=""></object>} {/*eslint-disable-line */}
      <div className="ChemPesticidePreview__BtnDiv">
        <Button
          onClick={() => handleClosePreview()}
          disabled={loading}
        >
          Close
        </Button>
        <Button
          type="primary"
          onClick={() => handleSubmitReport()}
          loading={loading}
        >
          Generate Report
        </Button>
      </div>
    </Modal>
  );
}

export default ChemPesticidePreview;
